import React from 'react';
import {CommonShow} from '../Common';
import {getFields} from './Common';

export const ContractShow = props => (
  <CommonShow
    {...{
      ...props,
      fields: getFields(),
    }}
  />
);
